import { Box } from "@mui/material"
import { makeStyles } from "@mui/styles"
import MUIRichTextEditor from "mui-rte"
import React, { useEffect, useRef } from "react"

const useStyles = makeStyles(() => ({
    rte: {
        width: "100%",
        "& img": {
            maxWidth: "100%",
            height: "auto"
        },
        "& video": {
            maxWidth: "100%",
            height: "auto"
        },
        "& a": {
            cursor: "pointer",
            color: "#1976d2",
            textDecoration: "underline",
            "&:hover": {
                color: "#1565c0"
            }
        }
    }
}))

const BodyRichContent = ({ content }: any) => {
    const classes = useStyles()
    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (containerRef.current) {
            const links = containerRef.current.querySelectorAll('a')
            links.forEach((link) => {
                const href = link.getAttribute('href')
                if (href) {
                    const isExternal = !href.startsWith('/') && !href.startsWith(window.location.origin)
                    const needsProtocol = isExternal && !href.startsWith('http')

                    if (needsProtocol) {
                        link.setAttribute('href', `https://${href}`)
                    }

                    if (isExternal) {
                        link.setAttribute('target', '_blank')
                        link.setAttribute('rel', 'noopener noreferrer')
                    }
                }
            })
        }
    }, [content])

    return (
        <Box className={classes.rte} ref={containerRef}>
            <MUIRichTextEditor defaultValue={content} readOnly={true} toolbar={false} />
        </Box>
    )
}

export default BodyRichContent  